import axios from '@/axios'

const filenameFromDisposition = (header, fallback) => {
  const match = /filename="?([^"]+)"?/i.exec(header || '')
  return match && match[1] ? match[1] : fallback
}

const messageFromError = async (error, fallback) => {
  const data = error && error.response && error.response.data
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text())
      if (parsed && parsed.message) return parsed.message
    } catch (parseError) {
      return fallback
    }
  }
  if (data && data.message) return data.message
  return fallback
}

export async function downloadAuthorizedFile ({ url, params, fallbackName, fallbackError }) {
  try {
    const response = await axios.get(url, { params, responseType: 'blob' })
    const contentType = response.headers['content-type']
    const blob = new Blob([response.data], contentType ? { type: contentType } : undefined)
    const filename = filenameFromDisposition(response.headers['content-disposition'], fallbackName)
    const link = document.createElement('a')
    const objectUrl = URL.createObjectURL(blob)
    link.href = objectUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(objectUrl)
  } catch (error) {
    throw new Error(await messageFromError(error, fallbackError))
  }
}
